<template>
  <div id="basketball_team" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <template v-if="!noData">
      <div class="teamList">
        <span
          class="teamItem"
          v-for="item in teamList"
          :key="item.teamId"
          :class="item.className ? item.className : ''"
          @click="goToDetail(item)"
        >
          <span class="teamItem_main">
            <span class="teamLogo">
              <img :src="item.teamLogo" />
            </span>
            <span class="teamOther">
              <span class="teamOther_name" v-text="item.teamName"></span>
              <span class="teamOther_winloss" v-text="item.winlossText"></span>
            </span>
          </span>
        </span>
      </div>
    </template>
    <template v-else>
      <cup_notData className="relativePtb60"></cup_notData>
    </template>
  </div>
</template>

<script>
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_notData from '@components/base/NO_DATA.vue'

import {
  https_basketball_seasonList,
  https_season_teamList,
} from '@api/platfrom_basketball_api'
export default {
  name: 'basketball_team',
  components: { marathon_select_opt, cup_notData },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      seasonArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'season',
            title: '赛季',
            origin_keyVal: ['seasonId', 'seasonName'],
            dataName: 'seasonArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      teamList: null,
    }
  },
  created() {
    console.debug('route:', this.$route)
    const query = this.$route.query
    this.selectTab_pageJumpParams = [query, null]
    if (query) {
      this.init(query)
    }
  },
  computed: {
    noData() {
      return this.teamList && this.teamList.length === 0
    },
  },
  methods: {
    async init(params) {
      // this.origin_matchList = matchList_mock.dat
      await this.getSeasonList()
      this.computedSelectOpt(this.selectOptData.configArr)
      await this.getTeamList(params)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate, // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt:',
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'season') {
            this.currStageSeason = valPathArr[1]
            // this.computedSelectOpt(this.selectOptData.configArr)
          } else {
          }
          // 筛选表格逻辑
          this.getTeamList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    goToDetail(item) {
      // console.debug(this.$route)
      const leagueType =
        this.$route.meta && this.$route.meta.pathModule
          ? this.$route.meta.pathModule[1]
          : ''
      const query = {
        tid: item.teamId,
      }
      this.pageJump(this.$router, `teamDetailIndex_${leagueType}`, query)
    },
    async getSeasonList() {
      await https_basketball_seasonList(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            this.seasonArr = res.data
            this.currStageSeason = this.seasonArr[0].seasonId
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getTeamList() {
      await https_season_teamList(this.axiosBaseUrl, this.$axios, {
        sid: this.currStageSeason,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.teamList = res.data.map((item, itemIndex) => {
              item.winlossText = `${this._valPerFormatHandler(
                item.wins
              )}胜${this._valPerFormatHandler(item.losses)}负`

              if (itemIndex % 8 < 4) {
                item.className = 'odd'
              }
              return item
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#basketball_team {
  padding-top: 2.083vw;
  .teamList {
    padding: 1.388vw 0 2.778vw 0;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .teamItem {
      position: relative;
      margin-right: 0.208vw;
      padding-top: 9.6%;
      width: calc(25% - 0.208vw);
      .teamItem_main {
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 2;
        transform: translateY(-50%);
        padding: 0 1.388vw;
        width: 100%;
        height: 4.86vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        .teamLogo {
          width: 4.86vw;
          height: 4.86vw;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .teamOther {
          width: calc(100% - 4.86vw);
          padding: 0 0.694vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .teamOther_name {
            width: 100%;
            font-size: 1.388vw;
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            height: 2.778vw;
            line-height: 2.778vw;
            color: var(--mixtmt_greyColor3);
          }
          .teamOther_winloss {
            width: 100%;
            font-size: 0.974vw;
            line-height: 2.082vw;
            height: 2.082vw;
            color: rgba(35, 98, 178, 1);
            font-weight: bold;
          }
        }
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
      &.odd {
        background-color: rgba(246, 246, 246, 1);
      }
    }
  }
}

.mixtmt_pc #basketball_team {
  .teamItem {
    &:hover {
      cursor: pointer;
      background-color: rgba(231, 242, 255, 1);
    }
  }
}
</style>
